import './global'; // Must live at top of this file in order to offer access to every other file.

import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import storeData from './configureStore';
import './api/events';
import './index.scss';
import App from './App';

const { store } = storeData;
const rootElement = document.getElementById('root');

ReactDOM.render(
  <Provider store={store}>
    <App />
  </Provider>,
  rootElement
);
